import { UrlStateConfig, UseUrlState, useUrlState } from './urlState';

type UrlStateV2<Values extends UrlStateConfig> = [
  UseUrlState<Values>['urlParams'],
  UseUrlState<Values>['updateUrlParams'],
  UseUrlState<Values>['clear'],
];

export function useUrlStateV2<Values extends UrlStateConfig = UrlStateConfig>(
  values: Values = {} as Values,
): UrlStateV2<Values> {
  const { updateUrlParams, urlParams, clear } = useUrlState(values);

  return [urlParams, updateUrlParams, clear];
}
